import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'


function MLHOPCoverages({ valuablePersonalProperties_ML, schedulePersonalProperties_ML, mineSubsidenceScheduledPvtStructureItem, optionalCoverages_ML, getFormattedCurrency, show }) {
    const translator = useTranslator();

    const AdditionalLocationCoverages = optionalCoverages_ML?.find((coverage) => coverage.name === "Additional Location - Not Rented To Others");
    const AdditionalLocation = AdditionalLocationCoverages?.scheduledItems_ML?.additionalLocationNotRented;

    const generateAdditionalLocationPropertiesTable = () => {
        if (!AdditionalLocation?.length > 0) {
            return (<></>);
        }
        return (
            <>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.AddressLine1)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.addressLine1}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.AddressLine2)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.addressLine2}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.City)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.city}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.ZipCode)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.zipCode}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.State)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.state}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.NumberOfFamilies)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.numberOfFamilies.chosenTermValue}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.DescriptionOfProperty)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.description}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.TypeOfProperty)}</strong></td>
                    {AdditionalLocation.map((location) => {
                        return <td>{location.typeOfProperty.chosenTermValue}</td>;
                    })}
                </tr>
            </>

        );
    };

    const generateValuablePersonalPropertiesTable = () => {
        if (!valuablePersonalProperties_ML.length > 0) {
            return (<></>);
        }
        return (
            <div>
                <h2 className="subsection-header vertical-spacing-20">
                    {translator(messages.ValuableProperty)}
                </h2>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>{translator(messages.ItemType)}</th>
                            <th>{translator(messages.PerItem)}</th>
                            <th>{translator(messages.TotalLimit)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {valuablePersonalProperties_ML.map((prop) => {
                            return (
                                <tr>
                                    <td>{prop.type.chosenTermValue}</td>
                                    <td>{prop.perItemLimit.chosenTermValue}</td>
                                    <td>{prop.aggregateLimit.chosenTermValue}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    const generateSchedulePersonalPropertiesTable = () => {
        if (!schedulePersonalProperties_ML.length > 0) {
            return (<></>);
        }
        return (
            <>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.ItemType)}</strong></td>
                    {schedulePersonalProperties_ML.map((prop) => {
                        return <td>{prop.type.chosenTermValue}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.Deductible)}</strong></td>
                    {schedulePersonalProperties_ML.map((prop) => {
                        return <td>{prop.deductible.chosenTermValue}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.LossSettlement)}</strong></td>
                    {schedulePersonalProperties_ML.map((prop) => {
                        return <td>{prop.lossSettlement.chosenTermValue}</td>;
                    })}
                </tr>
                <tr>
                    <td className="col-md-3 sub-cell"><strong>{translator(messages.Value)}</strong></td>
                    {schedulePersonalProperties_ML.map((prop) => {
                        return <td>{prop.itemValue}</td>;
                    })}
                </tr>
            </>
        );
    }

    const getMineSubsidenceScheduledPvtStructureTable = () => {
        if (!mineSubsidenceScheduledPvtStructureItem?.length > 0) {
            return (<></>);
        }
        return (
          <>
            <div>
              <h2 className="subsection-header vertical-spacing-20">
                {translator(messages.MineSubTitle)}
              </h2>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>{translator(messages.MineSubDescriptionOfProperty)}</th>
                    <th>{translator(messages.MineSubLimit)}</th>
                    <th>{translator(messages.MineSubDeductible)}</th>
                    <th>{translator(messages.MineSubIsLocatedOnPremise)}</th>
                  </tr>
                </thead>
                <tbody>
                  {mineSubsidenceScheduledPvtStructureItem.map((prop) => {
                    return (
                      <tr>
                        <td>{prop.description}</td>
                        <td>{prop.limit}</td>
                        <td>{prop.deductible.chosenTermValue}</td>
                        <td>{prop.isLocatedOnPrimaryInsuredPremise.chosenTermValue}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        );
    }

    const generateOptionalCoveragesTable = () => {
        if (!optionalCoverages_ML.length > 0) {
            return (<></>);
        }
        return (
            <div className="vertical-spacing-40">
                <table className={`table table-striped table-bordered table-data-vertical ${styles.noLeftRightBorders}`}>
                    {optionalCoverages_ML?.filter(opCoverage=> opCoverage?.name !== translator(messages.ValuableProperty))?.map((coverage) => {
                        return (
                            <tbody>
                                <tr />
                                {(coverage.selected)?
                                    <tr>
                                        <td colSpan="2">
                                            <h2 className="subsection-header">{coverage.name}</h2>
                                        </td>
                                    </tr> : <></>
                                }
                                {
                                    coverage.name === "Scheduled Personal Property" ? generateSchedulePersonalPropertiesTable() : <></>
                                }
                                {
                                    coverage.name === "Additional Location - Not Rented To Others" ? generateAdditionalLocationPropertiesTable() 
                                        : <></>
                                }
                                {
                                    (coverage.terms.map((term) => {
                                        return (
                                            (coverage.selected && coverage.terms.length > 0 && term.isVisible_ML)?
                                                <tr>
                                                    <td className="col-md-3 sub-cell"><strong>{term.name}</strong></td>
                                                    <td>{term.chosenTermValue}</td>
                                                </tr> : <></>
                                        );
                                    }))
                                }
                            </tbody>
                        );
                    })}
                </table>
            </div>
        );
    };

    if (show) {
        return (
            <>
                <div className="vertical-spacing-40">
                    <h2 className="section-header vertical-spacing-20">
                        {translator(messages.OptionalCoverages)}
                    </h2>
                    {generateValuablePersonalPropertiesTable()}
                </div>
                {generateOptionalCoveragesTable()}
                {getMineSubsidenceScheduledPvtStructureTable()}
            </>
        );
    }
    return ( <></> );
}

MLHOPCoverages.propTypes = {
    valuablePersonalProperties_ML: PropTypes.shape([]),
    schedulePersonalProperties_ML: PropTypes.shape([]),
    mineSubsidenceScheduledPvtStructureItem: PropTypes.shape([]),
    optionalCoverages_ML: PropTypes.shape([]),
    getFormattedCurrency: PropTypes.func.isRequired,
    show: PropTypes.bool
};
MLHOPCoverages.defaultProps = {
    valuablePersonalProperties_ML: [],
    schedulePersonalProperties_ML: [],
    mineSubsidenceScheduledPvtStructureItem: [],
    optionalCoverages_ML: [],
    show: false
};
export default MLHOPCoverages;
